import { AppConfig } from '@ltvco/refresh-lib/ctx';
import {
  Button,
  Divider,
  Grid,
  Stack,
  Text,
  Card,
} from '@ltvco/refresh-lib/theme';
import { useSessionEscalation } from '@ltvco/refresh-lib/v1';
import { useContext } from 'react';

import idMonitorBlueLogo from 'images/id-monitor-blue-logo.svg';

import { GetStartedSummaryDetailsProps, getSummaries } from './constants';

const GetStartedSummaryDetails: React.FC<GetStartedSummaryDetailsProps> = ({
  img,
  title,
  summary,
}) => {
  return (
    <Grid size={{ xs: 12, sm: 5.9 }}>
      <Stack direction="row" alignItems="flex-start" textAlign="left">
        <img src={img} width="35px" height="35px" alt="id-monitor-summary" />
        <Stack direction="column" sx={{ marginLeft: '12px' }}>
          <Text variant="h1" fontSize="16px" sx={{ marginBottom: '4px' }}>
            {title}
          </Text>
          <Text variant="body1">{summary}</Text>
        </Stack>
      </Stack>
    </Grid>
  );
};

export const Summaries = () => {
  const { trackEvent, trackEventGA4 } = useContext(AppConfig);

  const {
    checkSessionEscalation: { refetch: getSessionEscalation },
  } = useSessionEscalation();

  const handleClick = () => {
    trackEvent('id monitor start', 'navigation click', 'id monitor enrollment');
    trackEventGA4({
      event_name: 'id_monitor_enrollment',
      step: 'id_monitor_start',
    });
    getSessionEscalation();
  };

  // Get the correct summaries based on the variation
  const summariesForVariation = getSummaries();

  const logoSrc = idMonitorBlueLogo;
  const content = (
    <>
      <img src={logoSrc} alt="id-monitor-color-logo" />
      <Text variant="h2" fontSize="30px" fontWeight="bold">
        ID Monitor
      </Text>
      <Text variant="h2" fontSize="20px" textAlign="center">
        Maximize your credit and identity management tools by connecting your
        credit record from TransUnion®
      </Text>
      <Grid
        container
        marginTop={4}
        sx={{
          marginBottom: [2, 2.5],
          border: 'none',
          borderRadius: 0,
          rowGap: [2, 2.5],
          padding: [2, 2.5],
          justifyContent: ['default', 'space-between'],
        }}
      >
        {summariesForVariation.map((summary) => (
          <GetStartedSummaryDetails
            key={summary.title}
            img={summary.img}
            title={summary.title}
            summary={summary.summary}
          />
        ))}
      </Grid>
      <Button
        onClick={() => handleClick()}
        variant="contained"
        sx={{
          width: ['100%', '172px'],
        }}
      >
        Get Started
      </Button>
      <Divider sx={{ marginY: [2, 2.5], width: '100%' }} />
      <Text marginBottom={[2, 2.5]} color="#757575">
        *Please answer required personal information to verify your identity and
        allow us to perform a soft pull on your TransUnion credit record. A soft
        pull does NOT affect your credit score.
      </Text>
    </>
  );

  return (
    <Card
      sx={{
        padding: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {content}
    </Card>
  );
};
